export const OperativeDetailGear = () => {
    return (
      <h1 className="text-white text-5xl">It is being worked on</h1>
    );
  }